export default {
  toasts: {
    printing: 'Drukowanie...',
    print_failed: 'Drukowanie nie powiodło się. Spróbuj ponownie',
    orders: {
      print_one: 'Drukowanie {{count}} paragonu: Zamówienie <strong>#{{orderNumber}}</strong>...',
      print_few: 'Drukowanie {{count}} paragonów: zamówienie <strong>#{{orderNumber}}</strong>...',
      print_many: 'Drukowanie {{count}} paragonów: zamówienie <strong>#{{orderNumber}}</strong>...',
      print_other: 'Drukowanie {{count}} paragonów: Zamówienie <strong>#{{orderNumber}}</strong>...',
    },
  },
};
